<nav class="mb-comms-topbar">
  <!-- Logo -->
  <div class="mb-comms-logo">
    <img src="/images/logo-main.png" />
  </div>

  <!-- Session Timer -->
  <div class="mb-comms-time">
    <div class="mb-comms-time-title">TIME REMAINING</div>
    <div class="mb-comms-time-content" [class.ending-soon]="endingSoon">{{timeRemaining}}</div>
  </div>

  <!-- User images -->
  <div class="mb-comms-profile-pics">

    <div class="mb-comms-profile-pic-sec mb-comms-pic-counsellor">
      <img *ngIf="session.me.profileImage != null" [src]="session.me.profileImage">
    </div>
    <div class="mb-comms-profile-pic-splitter">---</div>
    <div class="mb-comms-profile-pic-sec mb-comms-pic-client">
      <img *ngIf="session.otherParty.profileImage != null" [src]="session.otherParty.profileImage">
    </div>

  </div>

  <!-- Connection Status -->
  <div class="mb-comms-modal-btn-wrap" *ngIf="session.sessionType == 4">
    <a href="" data-toggle="modal" data-target=".mb-comms-modal">
      <div class="col-xs-7 nopadding">
        <div *ngIf="comms.isOtherPartyOnline" class="menu-status-a"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
          Connected</div>
        <div *ngIf="!comms.isOtherPartyOnline" class="menu-status-b"><i class="fa fa-exclamation-triangle"
            aria-hidden="true"></i> Disconnected</div>
      </div>

      <div class="col-xs-5 nopadding">
        <div class="menu-wrap"><i class="fa fa-bars" aria-hidden="true"></i>&nbsp; Menu</div>
      </div>

      <div class="clear"></div>
    </a>
  </div>
  <div class="mb-comms-modal-btn-wrap" *ngIf="session.sessionType != 4">
    <a href="" data-toggle="modal" data-target=".mb-comms-modal">
      <div class="col-xs-12 nopadding">
        <div class="menu-wrap"><i class="fa fa-bars" aria-hidden="true"></i>&nbsp; Menu</div>
      </div>
      <div class="clear"></div>
    </a>
  </div>

</nav>

<div class="clear"></div>

<browser-modal></browser-modal>

<div class="modal fade mb-comms-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  aria-hidden="true" style="padding-right:0;">
  <div class="modal-dialog">
    <div class="mb-comms-modal-inner">
      <!-- close button -->
      <div class="mb-comms-modal-close">
        <button type="button" data-dismiss="modal"><span class="fa fa-times"></span></button>
      </div>

      <!-- Session Type -->
      <div class="mb-session-title">
        <h2>{{sessionType}}</h2>
      </div>


      <div class="mb-session-identity">

        <!-- Me - Pro or Client -->
        <div class="col-xs-6">
          <div class="mb-session-identity-user-image">
            <img *ngIf="session.me.profileImage == null" src="/images/ucsession1.jpg">
            <img *ngIf="session.me.profileImage != null" [src]="session.me.profileImage">
          </div>
          <div class="mb-session-identity-user-name">{{session.me.name}}
            <br /><span *ngIf="session.me.mbNumber != null">MB{{session.me.mbNumber}}</span>
          </div>
        </div>

        <div class="col-xs-6">
          <div class="mb-session-identity-user-image">
            <img *ngIf="session.otherParty.profileImage == null" src="/images/ucsession1.jpg">
            <img *ngIf="session.otherParty.profileImage != null" [src]="session.otherParty.profileImage">
          </div>
          <div class="mb-session-identity-user-name">{{session.otherParty.name}}
            <br /><span *ngIf="session.otherParty.mbNumber != null">MB{{session.otherParty.mbNumber}}</span>
          </div>
        </div>

      </div>

      <div class="clear"></div>

      <div class="mb-session-sidebar-splitter"></div>

      <!-- Session Timer -->
      <div class="mb-session-timer-wrap">
        <div class="mb-session-sidebar-title">Time Remaining</div>
        <div class="mb-session-timer-sec">{{timeRemaining}}</div>
      </div>

      <div class="mb-session-sidebar-splitter"></div>

      <div class="mb-sidebar-button-full">
        <div class="col-xs-6 col-xs-offset-3">
          <button class="button-red" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
